import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/baracca/Navbar";
import Hero from "@/components/baracca/Hero";
import Marquee from "@/components/baracca/Marquee";
import Storia from "@/components/baracca/Storia";
import Piatti from "@/components/baracca/Piatti";
import Menu from "@/components/baracca/Menu";
import Orari from "@/components/baracca/Orari";
import Contatti from "@/components/baracca/Contatti";
import Footer from "@/components/baracca/Footer";
import ChatWidget from "@/components/baracca/ChatWidget";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const target = document.querySelector(a.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -72 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-[#FAF8F5] text-[#1C1917]">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Storia />
        <Piatti />
        <Menu />
        <Orari />
        <Contatti />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}

export default App;
